import { get } from '../client'
import type {
  AchievementsPageResponse,
  AchievementsProgressResponse,
  BadgeCategoriesResponse,
} from '../types/generated'

export async function getAchievements(): Promise<AchievementsPageResponse> {
  return get<AchievementsPageResponse>('api/candidate/achievements')
}

export async function getAchievementsProgress(): Promise<AchievementsProgressResponse> {
  return get<AchievementsProgressResponse>('api/candidate/achievements/progress')
}

export async function getAchievementCategories(): Promise<BadgeCategoriesResponse> {
  return get<BadgeCategoriesResponse>('api/candidate/achievements/categories')
}
